package com.loyola.acessoescola.ui.adminpanel

fun String.toCpfFormat(): String {
    val numbers = this.filter { it.isDigit() }

    return if (numbers.length == 11) {
        numbers.replace(
            Regex("(\\d{3})(\\d{3})(\\d{3})(\\d{2})"),
            "$1.$2.$3-$4"
        )
    } else {
        this
    }
}

fun String.toPhoneFormat(): String {
    val numbers = this.filter { it.isDigit() }

    return if (numbers.length == 11) {
        numbers.replace(
            Regex("(\\d{2})(\\d{1})(\\d{4})(\\d{4})"),
            "($1) $2 $3-$4"
        )
    } else {
        this
    }
}

fun String.toBrazilianDateTime(): String {
    return try {
        val dateTime = substringBefore(".")
        val (date, time) = dateTime.split("T")
        val (year, month, day) = date.split("-")

        "$day/$month/$year $time"
    } catch (_: Exception) {
        this
    }
}